import { defineComponent as _defineComponent } from 'vue'
import SeasonSelector from '@/components/admin/season-dropdown.vue';
import { useAuth } from '@/store/auth';
import { useBuilderStore } from '@/store/builder';
import { adminGetInfo } from '@/util/functions';
import { computed, ref } from 'vue';
import SimpleModal from '../SimpleModal.vue';
import { Season } from '@busy-human/hxp-library';
import { useSeasons } from '@/store/seasons';
import { useRouter } from 'vue-router';
import { useSeasonFeature } from '@/composables/useSeasonFeature';
import { useToast } from 'vue-toastification';

type Emits = {
	(e: 'openTripAssignment'): void
	(e: 'close'): void
}
const overrideTimeout = 2000;

export default /*#__PURE__*/_defineComponent({
  __name: 'admin-popup',
  emits: ["openTripAssignment", "close"],
  setup(__props, { expose: __expose }) {
  __expose();

const seasonStore = useSeasons();
const router = useRouter();
const toast = useToast();



const adminOverrideEmail = ref('');
const adminOverrideLog = ref('');
const selectedSeason = ref();

const registrationEnabled = useSeasonFeature(Season.Features.REGISTRATION);
const checklistEnabled = useSeasonFeature(Season.Features.CHECKLIST);

const routeToPage = (link: string) => {
	router.push(link);
};

const adminPanelState = ref<'proxy' | 'flags' | 'season'>('proxy');

async function doAdminOverride() {
	const authstore = useAuth();
	adminOverrideLog.value = '';
	if(!authstore.isAdmin) throw new Error("Not an admin!");

	adminOverrideLog.value += 'Getting user details\n';
	try {
		const { data } = await adminGetInfo({email: adminOverrideEmail.value});
		adminOverrideLog.value += `User ID: ${data.uid}\n`;
		adminOverrideLog.value += `BuilderID: ${data.builderId}\n`;
		adminOverrideLog.value += `RootUID: ${data.rootUID}`;

		adminOverrideLog.value += `Setting UID...\n`;
		authstore.setCurrentUID(data.uid);

		if(data.builderId) {
			adminOverrideLog.value += `Tracking builder...\n`;
			await new Promise(res => {setTimeout(res, overrideTimeout);});
			const builderStore = useBuilderStore();
			await builderStore.manuallyTrackBuilder(data.builderId);
		}

		if(seasonStore.hasAnyFlagOverrides) {
			toast.warning("You have season flag overrides set. Some season features may be different compared to what the proxied user sees. Use the Season Flags tab to reset your overrides.", {timeout: false});
		}

		adminOverrideLog.value += `Done! Click outside this modal to continue.\n`;
	} catch (e) {
		adminOverrideLog.value += `Error: ${(e as Error).message}\n`;
	}
}

function clearAdminOverride() {
	const authstore = useAuth();
	authstore.resetCurrentUID();
	adminOverrideLog.value = 'Override Cleared';
	adminOverrideEmail.value = '';
}

const __returned__ = { seasonStore, router, toast, adminOverrideEmail, adminOverrideLog, overrideTimeout, selectedSeason, registrationEnabled, checklistEnabled, routeToPage, adminPanelState, doAdminOverride, clearAdminOverride, SeasonSelector, get useAuth() { return useAuth }, get useBuilderStore() { return useBuilderStore }, get adminGetInfo() { return adminGetInfo }, computed, ref, SimpleModal, get Season() { return Season }, get useSeasons() { return useSeasons }, get useRouter() { return useRouter }, get useSeasonFeature() { return useSeasonFeature }, get useToast() { return useToast } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})